import 'split-pane-react/esm/themes/default.css'
import './index.css'

import { LicenseInfo as MuiProLicenseInfo } from '@mui/x-license'
import { Provider } from 'react-redux'
import { RecoilRoot } from 'recoil'
import { ThemeProvider } from 'styled-components'

import { ChainlitProvider } from '@/features/aiAssistant/providers'
import * as theme from '@/styles'

import { AppContextWrapper } from './context/AppContext/AppContextWrapper'
import { AuthContextProvider } from './context/AuthContext/AuthContext'
import { App } from './pages/App/App'
import { store } from './store'

type RootProps = {
	token?: string
}

MuiProLicenseInfo.setLicenseKey(
	'9d47cb9004854e21dd8bb331d619f9c0Tz0xMjE3MDIsRT0xNzk0NTI3OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
)

export const Root = ({ token }: RootProps) => {
	return (
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<AuthContextProvider>
					<AppContextWrapper>
						<ChainlitProvider>
							<RecoilRoot>
								<App token={token} />
							</RecoilRoot>
						</ChainlitProvider>
					</AppContextWrapper>
				</AuthContextProvider>
			</ThemeProvider>
		</Provider>
	)
}
